import React, { useEffect, useRef } from 'react'
import { App_url, FormKeywords } from '../utils/constants/static'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap';

gsap.registerPlugin(ScrollTrigger);
const Contact = () => {
    const sectionRef = useRef<HTMLDivElement>(null);
    const divRef = useRef<HTMLDivElement | null>(null);
    const keywordsRef = useRef<HTMLDivElement[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);
    const stripRef = useRef<HTMLDivElement>(null);
    const formFrontRef = useRef<HTMLDivElement>(null);
    const formBackRef = useRef<HTMLDivElement>(null);
    // const tearRef = useRef<HTMLDivElement>(null);


    // useEffect(() => {
    //     gsap.set([formFrontRef.current, formBackRef.current], { "--form-width": "5rem" });
    //     gsap.set(divRef.current, { "--value": 0 });

    //     gsap.fromTo(divRef.current, {
    //         rotate: 0, opacity: 1,
    //     }, {
    //         // rotate: "36deg",
    //         opacity: 0,
    //         ease: "linear",
    //         duration: 3,
    //         scrollTrigger: {
    //             trigger: divRef.current,
    //             start: "top+=100 bottom",
    //             end: "bottom top",
    //             scrub: true,
    //         }
    //     });

    //     gsap.fromTo(stripRef.current, {
    //         opacity: 1,
    //         y: 0,
    //         x: 0,
    //     }, {
    //         opacity: 0,
    //         y: '100',
    //         rotate: "36deg",
    //         ease: "power2.inOut",
    //         duration: 2,
    //         scrollTrigger: {
    //             trigger: stripRef.current,
    //             start: "top top+=200",
    //             end: "+=4000",
    //             scrub: true,
    //         }
    //     })

    //     const tl = gsap.timeline({
    //         scrollTrigger: {
    //             trigger: containerRef.current,
    //             start: "top top",
    //             end: "bottom top",
    //             scrub: true,
    //             // markers: true,
    //         },
    //     });

    //     const tl1 = gsap.timeline({
    //         scrollTrigger: {
    //             trigger: formFrontRef.current,
    //             start: "top top+=100",
    //             end: "bottom top",
    //             markers: true,
    //         }
    //     })

    //     tl.to(divRef.current, {
    //         "--value": 100,
    //         ease: "power2.inOut",
    //         duration: 3,
    //     });

    //     tl.to({}, { delay: 2.5 });

    //     tl1.to([formFrontRef.current, formBackRef.current], {
    //         "--form-width": "90rem",
    //         ease: "power2.inOut",
    //         duration: 3,
    //     }, ">0.5");

    //     tl.to({}, { duration: 1 })
    //     // gsap.to(divRef.current, {
    //     //     "--value": 100, duration: 2, ease: "power2.out",
    //     //     scrollTrigger: {
    //     //         trigger: divRef.current,
    //     //         start: "top top",
    //     //         end: "bottom top",
    //     //         scrub: true,
    //     //     }
    //     // });

    //     // tear-strip_strip
    //     // gsap.fromTo(stripRef, {
    //     //     opacity: 1,
    //     //     rotate: 0
    //     // }, {
    //     //     opacity: 0,
    //     //     rotate: '36deg', 
    //     //     pin: true,
    //     // })


    //     //     const tl = gsap.timeline({
    //     //     scrollTrigger: {
    //     //       trigger: sectionRef.current,
    //     //       start: "top 400",
    //     //       end: "bottom top+=100",
    //     //       scrub: 1.5,
    //     //       pin: true,
    //     //     //   markers: true,
    //     //     },
    //     //   });

    //     gsap.to(keywordsRef.current, {
    //         x: 0,
    //         y: 0,
    //         opacity: 0,
    //         ease: "power3.inOut",
    //         duration: 1,
    //         // stagger: 0.1,
    //         scrollTrigger: {
    //             trigger: containerRef.current,
    //             start: "top 500",
    //             end: "bottom top",
    //             scrub: 1.5,
    //             // markers: true,
    //         }
    //     });
    // }, [])

    useEffect(() => {

        // Initial setup
        gsap.set([formFrontRef.current, formBackRef.current], { "--form-width": "5rem" });
        gsap.set(divRef.current, { "--value": 0 });

        // Master timeline
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top top+=200",
                end: "+=3000",
                scrub: 1.2,
                //   pin: true,
                // markers: true,
            },
        });

        // Increase --value while moving the tear strip downward
        tl.to(divRef.current, {
            "--value": 100,
            ease: "none",
            duration: 3,
        });

        tl.to(
            stripRef.current,
            {
                //   yPercent: 50,
                //   rotate: 36,
                opacity: 0,
                ease: "power3.inOut",
                duration: 3,
            },
            "<" // start at the same time as --value increasing
        );

        //   tl.to(divRef.current, {
        //     opacity: 0,
        //     ease: "power2.inOut",
        //     duration: 5,
        //   }, "<")

        tl.to(keywordsRef.current, {
            x: 0,
            y: 0,
            opacity: 0,
            duration: 3,
            ease: "power3.inOut"
        }, "<");

        // Reveal the background form as strip moves down
        tl.to(
            formBackRef.current,
            {
                opacity: 1,
                duration: 1.5,
                ease: "power1.inOut",
            },
            "<0.5" // starts slightly after motion begins
        );

        //  Expand the form width
        tl.to(
            [formFrontRef.current, formBackRef.current],
            {
                "--form-width": "90rem",
                ease: "power2.inOut",
                duration: 3,
            },
            ">0.3"
        );

        tl.to({}, { duration: 4 });

        return () => {
            ScrollTrigger.getAll().forEach((st) => st.kill());
        };
    }, []);



    return (
        <div id='contact' className='h-[400vh]' ref={containerRef}>
            <section className='sticky top-[calc(-22.4rem-10vh)] h-fit w-full flex flex-col items-center bg-cover bg-center bg-no-repeat z-4' style={{ backgroundImage: `url(${App_url.image.contact_bg})` }}>
                {/* form intro text */}
                <div>
                    <div id='intro' className="relative w-full mt-[10rem] font-['sahitya',serif] text-[1.3rem] leading-[106%] text-center">
                        <p className='uppercase'>Invitation to the thorned<br /> gathering<br /> an evening of power, elegance,<br /> and quiet dominion</p>
                    </div>
                </div>
                {/* Rip area in form */}
                <div id='rip-area' className='flex flex-col items-center mt-[100px] pt-[100px] mb-[15rem]'>
                    {/* Keywords letters */}
                    <div className='absolute top-[30%] left-1/2 -translate-x-1/2'>
                        {FormKeywords.map((item, i) => (
                            <div key={item.id} ref={(el) => { keywordsRef.current[i] = el! }} id='keywords' className={`absolute whitespace-nowrap font-['sahitya',_serif] text-[1.5rem] translate-x-${item.x} translate-y-${item.y}`} style={{ transform: `translate(${item.x}, ${item.y})`, opacity: 0.8 }}>{item.name}</div>
                        ))}
                    </div>
                    {/* Content Wrap */}
                    <div className='form-ref absolute flex flex-col items-center w-[calc(100vw - 84px)]'>
                        {/* rip extend part */}
                        <div
                            id='form-content'
                            ref={formFrontRef}
                            className='relative w-[var(--form-width)] flex flex-col items-center justify-center h-[var(--rip-height)] overflow-clip'
                        // style={{ zIndex: 2 }}
                        >
                            {/* form content */}
                            <div className='absolute w-[calc(100vw-84px)] h-[var(--rip-height)] bg-[#DADADA] shadow-[inset_0px_0px_6px_4px_#00000035] !p-[50px] flex flex-col items-center !gap-[5rem]'>
                                {/* form logo */}
                                <div className='w-[420px] h-auto'>
                                    <img
                                        src={App_url.image.form_logo}
                                        alt='form logo'
                                        className='h-full w-full object-cover'
                                    />
                                </div>
                                {/* form content */}
                                <div className='w-[500px] text-black flex flex-col gap-[1.6rem]'>
                                    <div className='flex flex-col h-[70px]'>
                                        <label className='text-[var(--fs-base)] ml-[1rem] transition-colors duration-300 ease-out text-[#9e9e9e]'>Name</label>
                                        <input type='text' id='name' name='name' className='p-[12px] pointer-events-auto bg-none outline-none caret-black border-b border-b-black text-[#6c6c6c]' style={{ background: "none" }} />
                                    </div>
                                    <div className='flex flex-col h-[70px]'>
                                        <label className='text-[var(--fs-base)] ml-[1rem] transition-colors duration-300 ease-out text-[#9e9e9e]'>Code</label>
                                        <input type='text' id='code' name='code' className='p-[12px] pointer-events-auto bg-none outline-none caret-black border-b border-b-black text-[#6c6c6c]' style={{ background: "none" }} />
                                    </div>
                                </div>
                                <a href='#submit' className='text-black ml-[2rem] uppercase transition-all duration-300 ease-out pointer-events-auto cursor-pointer border-b border-b-black'> Build your Empire</a>
                            </div>
                        </div>
                        <div ref={formBackRef} className='absolute w-[var(--form-width)] h-[var(--rip-height)] bg-[length:400%_400%] bg-no-repeat [background-position:center center] pointer-events-none'
                            style={{
                                backgroundImage: `url(${App_url.image.contact_bg})`,
                                WebkitMaskImage: `url(${App_url.image.exclude_l}), url(${App_url.image.exclude_r})`,
                                WebkitMaskRepeat: 'repeat-y',
                                WebkitMaskPosition: 'left 20px, right 20px',
                                WebkitMaskSize: '14px 40px',
                                // zIndex: 99,
                                // width: 'var(--form-width)'
                                // WebkitMaskComposite: 'exclude',
                            }}>
                        </div>
                    </div>
                    {/*tear strips */}
                    <div
                        ref={divRef}
                        className='relative w-[84px] h-[var(--rip-height)] grid place-items-center [border-color:hsl(0_0%_85%)] text-[1.3rem] [container-type:size] pointer-events-none 
                            [--shadow-reveal:calc(var(--value,0)/100)] [--shadow-spread:calc(var(--value,0)/100)] [--bg-alpha:#670b0b6f] [--tab-darkness:80] [animation:sync_both_linear_reverse] [animation-timeline:--thumb] [animation-range:contain]'
                    // style={{ backgroundImage: `url(${App_url.image.contact_bg})` }}
                    >
                        <div className='absolute text-[0.9rem] text-center [writing-mode:vertical-lr] [text-orientation:mixed] rotate-180' aria-hidden="true" aria-live='off'></div>
                        <span id="tear-shadow" className="absolute w-full h-[20px] top-0 [transform-origin:50%_100%] [opacity:calc(1_-_(((var(--value,_0)_-_90)_/_10)_*_1))] 
                                                 [translate:0_-75%] [transform:translateY(calc(((var(--value,_0)_/_100)_*_(100cqh_-_20%))))] 
                                                 after:content-[''] after:absolute after:inset-0 after:[background:linear-gradient(180deg,transparent,hsla(0,93%,11%,0.5)] after:[filter:blur(8px)] after:[opacity:calc((1*(clamp(0,var(--value,0),20)/10)))]"
                        >
                        </span>
                        {/* strip initially */}
                        <div ref={stripRef} className='absolute inset-0 flex items-center justify-center  text-[hsl(0_0%_71%)] border-black'
                            style={{
                                backgroundImage: `url(${App_url.image.outline}), url(${App_url.image.contact_bg})`,
                                backgroundSize: '80px_39px,_400%_400%',
                                backgroundPosition: 'center_20px,_center_center',
                                backgroundRepeat: 'repeat, no-repeat',
                                clipPath: 'inset(calc(var(--value,_0)_*_1%)_0_-100%_0)]',
                                // zIndex: 10
                            }}
                        >
                            <div className='absolute top-0 text-[var(--fs-base)] text-black p-[2px] bg-[#D9D9D9] border border-black whitespace-nowrap [transform-origin:50%_100%] [transform:translate(0%,calc((var(--value,_0)/100)*150%))_scale(1,calc(1-((var(--value,_0)/100)*1)))]'>
                                LET IT RIP
                            </div>

                            <div id='strip_back' className='absolute w-full h-full bottom-full [transform-origin:50%_0%] [transform:translate(0,calc(var(--value,_0)*2%))]'>
                                <div id='strip_back_shadow' className='absolute bottom-0 left-1/2 w-full min-h-[500px] translate-x-[-50%] translate-y-0 z-1 [height:calc(var(--value,_0)*0.8%)] text-[hsl(0,100%,15%)]  [box-shadow:0_0_hsl(0_80%_calc((1-((var(--value,0)/100)*40))*1%))_calc(var(--shadow-spread,0)*100cqw)] mix-blend-multiply'></div>
                                <div
                                    id='strip_back_backing'
                                    className="absolute inset-0 [background:linear-gradient(180deg,hsl(0_0%_calc(var(--tab-darkness,40)*1%)_/var(--bg-alpha,1)),hsl(0_0%_100%_/var(--bg-alpha,1)),hsl(0_0%_80%_/var(--bg-alpha,1)))] [background-position:50%_100%] bg-no-repeat [background-color:hsl(0,81%,20%)] [background-size:100%_var(--bg-size)] 
                                    [filter:drop-shadow(2px_0px_4px_rgba(0,0,0,0.5))] before:content[''] before:absolute before:[inset:0_0_-8px_0] before:[filter:blur(4px)] before:rounded-[1000px] before:-z-[-1]  before:[background:radial-gradient(120%_200%,hsla(0,83%,36%,0.467),transparent_90%)] before:[opacity:var(--shadow-reveal,0)]"
                                    style={{ WebkitMaskImage: `url(${App_url.image.strip})`, maskRepeat: 'repeat', maskSize: '80px_40px', maskPosition: 'center_20px' }}
                                ></div>
                            </div>

                            <span id='strip-text' className='absolute bottom-[20%] [writing-mode:vertical-lr] [text-orientation:mixed] text-[10px]'></span>
                        </div>
                        <div className='absolute top-0 left-0 right-0 aspect-square bg-[hsl(210_80%_50%_/_0.1)] [opacity:calc((var(--intent,_0)*1)_-_var(--active,_0))] rounded-full [transform-origin:50%_100%] [translate:0_calc((var(--value,_0)/100)*(200cqh_+_-100%))]'></div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contact;